<template>
<div>
  <!-- <v-row>
    <v-col cols="12">
      <h1>國外國家地區代碼維護</h1>
    </v-col>
  </v-row> -->
   
  <VCard>
    <VCardText>
      <v-row>
        <v-col cols="6" md="3">
          <!-- {{selectedCountry}} -->
          <!-- {{allRegions}} -->
          <!-- {{allCountrys}} -->
          <v-autocomplete v-model="selectedCountry"
           :items="allCountrys"
           item-title="country"
           item-value="countryCode"
           prepend-inner-icon="tabler-search"
           label="請選擇國家"
           @update:model-value="selectCountryAction()"
           clearable
           ></v-autocomplete>
          <!-- <v-select 
          v-model="selectedCountry" 
          :items="allCountrys" 
          label="請選擇國家"
          item-title="country"
          item-value="countryCode"
          clearable
          ></v-select> -->
        </v-col>
        <v-col cols="6" md="3">
          <!-- {{allRegions}} -->
           <v-autocomplete v-model="selectedRegion"
          :items="allRegions" 
          no-data-text="尚無資料"
          item-title="region"
          item-value="regionCode"
          prepend-inner-icon="tabler-search"
          label="請選擇地區"
          :disabled="allRegions.length<1"
          clearable
          ></v-autocomplete>
          <!-- <v-select 
          v-model="selectedRegion" 
          :items="allRegions" 
          label="請選擇地區"
          :disabled="allRegions.length<1"
          item-title="region"
          item-value="regionCode"
          clearable
          ></v-select> -->
        </v-col>
        <v-col cols="12" md="6" class="d-flex justify-end">
          <v-btn variant="tonal"
          color="primary" prepend-icon="tabler-plus" 
          @click="openDialog(dialogActionStatus[0].value)">新增</v-btn>
          <v-btn 
          variant="tonal"
          :disabled="tableSelected.length>1||tableSelected.length<1"
          color="warning" prepend-icon="tabler-edit" 
          @click="openDialog(dialogActionStatus[1].valu)" class="ml-3">修改</v-btn>
          <v-btn 
          variant="tonal"
          :disabled="tableSelected.length<1"
          color="error" prepend-icon="tabler-trash"
          @click="deleteItem(tableSelected)" class="ml-3">刪除</v-btn>
        </v-col>
      </v-row>
    </VCardText>
    <VDataTableServer
      v-model:items-per-page="size"
      v-model:page="page"
      :items-length="totalData"
      v-model="tableSelected"
      item-value="id"
      show-select
      :headers="headers" 
      :items="items" 
      class="text-no-wrap border-t-sm rounded-0"
      no-data-text="尚無資料"
    >

      <template #bottom>
        <TablePagination
          v-model:page="page"
          v-model:size="size"
          :items-per-page="size"
          :total-items="totalData"
        />
      </template>
    </VDataTableServer>
  </VCard>

  <v-dialog v-if="dialog" v-model="dialog" max-width="600px" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">{{ dialogTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-radio-group v-model="radioGroup" row>
          <v-radio
            v-for="item in radioBtn"
            :key="item"
            :label="item.key"
            :value="item.value"
          ></v-radio>
        </v-radio-group>
        <v-form ref="formDialog">
          <v-container>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field 
                v-if="radioGroup==radioBtn[0].value"
                v-model="form.country" 
                :rules="[rules.required]"
                label="國家" 
                variant="outlined" 
                required></v-text-field>
                <!-- {{countrySelect}} -->
                <v-select 
                v-if="radioGroup==radioBtn[1].value"
                v-model="countrySelect" 
                :rules="[rules.required]"
                :items="allCountrys"
                label="國家" 
                variant="outlined"
                item-title="country"
                return-object
                required></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field 
                v-if="radioGroup==radioBtn[0].value"
                v-model="form.countryCode" 
                :rules="[rules.required]"
                label="國家代碼" 
                variant="outlined" 
                required></v-text-field>
                <v-select 
                v-if="radioGroup==radioBtn[1].value"
                v-model="countrySelect" 
                :rules="[rules.required]"
                :items="allCountrys"
                label="國家代碼" 
                item-title="countryCode"
                variant="outlined" 
                return-object
                required></v-select>
              </v-col>
              <v-col v-if="radioGroup==radioBtn[1].value" cols="12" sm="6">
                <v-text-field
                  :rules="[rules.required]"
                  v-model="form.region"
                  label="地區"
                  required
                ></v-text-field>
              </v-col>
              <v-col v-if="radioGroup==radioBtn[1].value" cols="12" sm="6">
                <v-text-field 
                :rules="[rules.required]"
                v-model="form.regionCode" 
                label="地區代碼" 
                variant="outlined" 
                required></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeDialog()">取消</v-btn>
        <v-btn color="blue darken-1" text @click="save">確認</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script setup lang="ts">
import { computed, onMounted, reactive } from "vue"
definePage({
  meta: {
    action: 'manage', //固定為 manage
    subject: 'COUNTRYAREACODE', //系統代碼(系統授權設定中的系統代碼)
  },
})

const formDialog = ref(null)
const selectedCountry=ref(null)
const selectedRegion=ref(null)
const headers=reactive([
  { title: '', key: 'checkbox', sortable: false },
  { title: '國家', key: 'country' },
  { title: '國家代碼', key: 'countryCode' },
  { title: '地區', key: 'region' },
  { title: '地區代碼', key: 'regionCode' },
])
const countrySelect = ref(null)
// Raido
const radioBtn=[
  {
    key:'國家',
    value:"country",
  },
  {
    key:'國家與地區',
    value:"countryRegion",
  },
]
const radioGroup =ref(radioBtn[1].value)

const tableSelected =ref([])
const items=reactive([])
const page=ref(1)
const size=ref( 10)
const totalData=ref(0)
const dialog=ref(false)
const dialogTitle=ref('')
const dialogActionStatus=[
  {
    key:'新增',
    value:'add'
  },
  {
    key:'修改',
    value:'edit'
  },
]
const dialogAction=ref(dialogActionStatus[0].value)
const form=reactive({
  country: '',
  region: '',
  countryCode: '',
  regionCode: '',
  prikey:'',
})
const menu=ref(false)
const rules = ref({
  required: (value: any) => !!value || '此欄位為必填',
});

const popSwal = (icon,title,text) => {
  if(icon=="success"){
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }else if (icon=="error"){
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      // timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }else{
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      // timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }
}

// API
// 查詢國家代碼select 
const { data: getAllCountrys, execute: getAllCountry } = await useApi<any>(createUrl('/tca/CountryAreaCode/getAllCountry', {
  // query: {
    // CountryAreaCode:null,
  // },
}))
const allCountrys = computed(()=>{
  return getAllCountrys.value.map((item)=>{
    return {
      country:item[1],
      countryCode:item[0]
    }
  })
})

const allRegions=reactive([])
//查詢國家代碼select 
const getAllRegions =async() =>{
  let countryCode = selectedCountry.value?selectedCountry.value:null
  try {
    const response = await $api('/tca/CountryAreaCode/getListByCountryCode', {
      method: 'POST',
      body:{
        countryCode,
      },
    });
    allRegions.splice(0 , allRegions.length , ...response)
  } catch (error) {
    console.error('Error during fetch:', error);
  }
}
//查詢國家地區代碼 API
const fetchData =async() =>{
  let countryCode = selectedCountry.value?selectedCountry.value:null
  let regionCode = selectedRegion.value?selectedRegion.value:null
  try {
    const response = await $api('/tca/CountryAreaCode/get', {
      method: 'POST',
      body: {
        countryCode,
        regionCode,
        page:page.value-1,
        size:size.value,
      },
    });
    totalData.value = response.totalElements
    items.splice(0 , items.length , ...response.content)
  } catch (error) {
    totalData.value = 0
    items.splice(0 , items.length )
    console.error('Error during fetch:', error);
  }
}

// 新增一筆國家地區 API
const add =async(body) =>{
  try {
    const response = await $api('/tca/CountryAreaCode/add', {
      method: 'POST',
      body: body,
    });
    if(response){
      popSwal('success','新增成功','')
    }
    dialog.value=false
    fetchData()
} catch (error) {
    popSwal('error','失敗 請稍後再試','')
  }
}
// 更新一筆國家地區 API
const update =async(body) =>{
  try {
    const response = await $api('/tca/CountryAreaCode/update', {
      method: 'POST',
      body: body,
    });
    if(response){
      popSwal('success','更新成功','')
    }
    dialog.value=false
    fetchData()
} catch (error) {
    popSwal('error','失敗 請稍後再試','')
  }
}
// 刪除國家地區 API
const deleteItem =async(body) =>{
  $swal({
    title: `刪除資料`,
    text: "",
    showCancelButton: true,
    confirmButtonText: "我要刪除",
    cancelButtonText: "取消",
  }).then(async(result) => {
    if (result.isConfirmed) {
      try {
        const response = await $api('/tca/CountryAreaCode/delete', {
          method: 'POST',
          body: body,
        });
        if(response){
          popSwal('success','刪除成功','')
        }
        tableSelected.value=[]
        dialog.value=false
        fetchData()
      } catch (error) {
        popSwal('error','失敗 請稍後再試','')
      }
    }
  })
}



// method
const openDialog = (type) => {
  dialogTitle.value = type == dialogActionStatus[0].value ? '新增國外國家地區代碼維護' : '修改國外國家地區代碼維護';
  if(type == dialogActionStatus[0].value){
    form.country=''
    form.countryCode=''
    form.region=''
    form.regionCode=''
    form.prikey=''
    countrySelect.value=null
    dialogAction.value=dialogActionStatus[0].value
  }else{
    const [ editData ] = items.filter((item)=>item.id===tableSelected.value[0])
    form.country=editData.country
    form.countryCode=editData.countryCode
    form.region=editData.region
    form.regionCode=editData.regionCode
    form.prikey=editData.prikey
    countrySelect.value={country:form.country,countryCode:form.countryCode}
    dialogAction.value=dialogActionStatus[1].value
    if(editData.regionCode&&editData.region){
      radioGroup.value=radioBtn[1].value
    }else{
      radioGroup.value=radioBtn[0].value
    }
  }
  dialog.value = true;
}
const closeDialog = () => {
  dialog.value = false
}

// v-form 驗證
const submitForm=async() => {
  const { valid } = await formDialog.value.validate();
  return valid
}

const clearForm = () =>{
  formDialog.value?.reset();
  form.effectiveDate =''
}

const dialogData = async() =>{
  let data ={
    prikey:form.prikey,
    country:form.country,
    countrycode:form.countryCode,
    region:form.region,
    regioncode:form.regionCode,
  }
  return data
}

const save = async() => {
  const valid = await submitForm();
  // 儲存邏輯
  if(valid){
    dialog.value=false
    if(dialogAction.value==dialogActionStatus[0].value){
      //新增時
      if(radioGroup.value ==radioBtn[0].value){
        const data =await dialogData()
        data.regioncode=""
        data.region=""
        data.prikey=''
        add(data)
      }else{
        const data =await dialogData()
        data.prikey=''
        add(data)
      }
    }else{
      //修改時
      console.log('ialogActionStatus[1].value')
      if(radioGroup.value ==radioBtn[0].value){
        const data =await dialogData()
        data.regioncode=""
        data.region=""
        update(data)
      }else{
        const data =await dialogData()
        update(data)
      }
    }
  }
}

const selectCountryAction =()=>{
  selectedRegion.value=null
  allRegions.splice(0,allRegions.length)
  if(selectedCountry.value){
    getAllRegions(selectedCountry.value)
  }
}

watch(size,()=>{
  fetchData()
})
watch(page,()=>{
  fetchData()
})
watch(items,()=>{
  getAllCountry()
  getAllRegions()
})

watch(countrySelect,()=>{
  if(countrySelect){
    form.country=countrySelect.value.country
    form.countryCode=countrySelect.value.countryCode
    console.log(form)
  }
})

watch(selectedCountry,()=>{
  // getAllRegions()
  fetchData()
})

onMounted(()=>{
  // getAllCountry()
  getAllRegions()
  fetchData()
})
</script>

<style scoped>
.headline {
  font-weight: bold;
}

</style>
